import { GetApple, GetGoogle } from 'common/config/assets';
import { OS_SYSTEM } from 'common/helpers/utils';

export const DownloadBySystems = {
  [OS_SYSTEM.IOS]: {
    image: GetApple,
    text: 'Download on the',
  },
  [OS_SYSTEM.ANDROID]: {
    image: GetGoogle,
    text: 'GET IT ON',
  },
};
